import * as React from 'react';

function Lethargic(props) {
	return (
		<svg
			width="61"
			height="61"
			viewBox="0 0 61 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M29.5864 60.0239C45.9265 60.0239 59.1728 46.7776 59.1728 30.4375C59.1728 14.0974 45.9265 0.851074 29.5864 0.851074C13.2463 0.851074 0 14.0974 0 30.4375C0 46.7776 13.2463 60.0239 29.5864 60.0239Z"
				fill="#C1A7ED"
			/>
			<path
				opacity="0.5"
				d="M35.9263 55.6559C19.5862 55.6559 6.34007 42.4097 6.34007 26.0696C6.34007 17.3397 10.1219 9.49405 16.1356 4.07861C6.55732 8.97603 0 18.9408 0 30.4372C0 46.7773 13.2462 60.0235 29.5863 60.0235C37.1965 60.0235 44.1347 57.1492 49.377 52.4283C45.3415 54.4917 40.77 55.6559 35.9263 55.6559Z"
				fill="#65318C"
			/>
			<path
				d="M25.3873 34.1164C22.4602 34.1164 19.8154 33.3675 18.313 32.1128C17.8027 31.6868 17.7346 30.9276 18.1607 30.4175C18.5867 29.9075 19.3459 29.8389 19.856 30.2652C20.9065 31.1425 23.0776 31.7093 25.3873 31.7093C27.6414 31.7093 29.8425 31.1317 30.9942 30.2381C31.5193 29.8307 32.2752 29.9261 32.6829 30.4512C33.0904 30.9764 32.9949 31.7326 32.4698 32.14C30.8747 33.3773 28.2269 34.1164 25.3873 34.1164Z"
				fill="#65318C"
			/>
			<path
				d="M46.2651 34.1164C43.338 34.1164 40.6934 33.3675 39.1909 32.1128C38.6807 31.6868 38.6126 30.9276 39.0386 30.4175C39.4645 29.9075 40.2235 29.8389 40.7339 30.2652C41.7844 31.1425 43.9555 31.7093 46.265 31.7093C48.5192 31.7093 50.7203 31.1317 51.8721 30.2381C52.3973 29.8307 53.1534 29.9261 53.5609 30.4512C53.9683 30.9764 53.8729 31.7326 53.3477 32.14C51.7526 33.3773 49.1048 34.1164 46.2651 34.1164Z"
				fill="#65318C"
			/>
			<path
				d="M35.5419 52.4407C38.2671 52.4407 40.4763 50.2315 40.4763 47.5062C40.4763 44.781 38.2671 42.5718 35.5419 42.5718C32.8167 42.5718 30.6074 44.781 30.6074 47.5062C30.6074 50.2315 32.8167 52.4407 35.5419 52.4407Z"
				fill="#65318C"
			/>
			<path
				d="M31.0977 21.947C30.8529 21.947 30.611 21.8588 30.4207 21.6892C30.1143 21.4162 30.002 20.9857 30.136 20.5979L31.2602 17.343L29.1114 18.4832C28.6152 18.7467 27.9993 18.5576 27.736 18.0616C27.4728 17.5653 27.6614 16.9496 28.1576 16.6862L32.5878 14.3353C32.9569 14.1397 33.4084 14.1893 33.726 14.4611C34.0435 14.7327 34.1625 15.1709 34.0262 15.5658L32.8543 18.9585L34.6138 18.1141C35.12 17.8714 35.7278 18.0844 35.9709 18.5911C36.2139 19.0975 36.0005 19.7052 35.494 19.9482L31.5374 21.8468C31.3973 21.9142 31.2471 21.947 31.0977 21.947Z"
				fill="#65318C"
			/>
			<path
				d="M41.0478 17.4183C40.8051 17.4183 40.5649 17.3316 40.3752 17.1643C40.0656 16.8915 39.9515 16.459 40.0862 16.0692L42.0366 10.4224L38.0274 12.5497C37.5312 12.8131 36.9154 12.624 36.652 12.1281C36.3888 11.6318 36.5774 11.0161 37.0736 10.7527L43.3641 7.41493C43.7333 7.21933 44.1847 7.26889 44.5023 7.54064C44.8198 7.81227 44.9389 8.25051 44.8025 8.64542L42.8176 14.3923L47.0857 12.2839C47.5896 12.0352 48.1993 12.2418 48.4482 12.7454C48.6969 13.2491 48.4903 13.859 47.9867 14.1078L41.4983 17.313C41.355 17.3838 41.2008 17.4183 41.0478 17.4183Z"
				fill="#65318C"
			/>
			<path
				d="M51.9241 12.2724C51.6793 12.2724 51.4374 12.1842 51.2471 12.0146C50.9407 11.7415 50.8284 11.311 50.9624 10.9232L53.6555 3.12601L47.9737 6.14075C47.4773 6.40417 46.8616 6.21515 46.5983 5.71915C46.3351 5.22291 46.5239 4.60721 47.0199 4.34378L54.983 0.118548C55.3522 -0.0770584 55.8036 -0.0274924 56.1212 0.244254C56.4388 0.515884 56.5577 0.954121 56.4213 1.34903L53.6807 9.28385L58.5951 6.92548C59.101 6.68251 59.7091 6.89579 59.9522 7.40243C60.1952 7.90883 59.9818 8.51656 59.4753 8.75954L52.3636 12.1723C52.2237 12.2394 52.0734 12.2724 51.9241 12.2724Z"
				fill="#65318C"
			/>
		</svg>
	);
}

export default Lethargic;
